import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  SZZA020AService,
  Szza020aRequest,
  Szza020aRequestBankMasterSrchInfDto,
  Szza020aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd002dSzza020aService {

  private _rsesult$ = new Subject<Szza020aResponse>();

  constructor(
    private szza020aService: SZZA020AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 指定された請求お客さま番号の請求先および請求情報を取得API呼び出し
   *
   * @param extBankfcCode 外部金融機関コード
   * @param extBranchCode 外部支店コード
   * @param date 日付
   * @memberof UsedSgkd02dSzza020aService
   */
  getBankInfo(extBankfcCode: string, extBranchCode: string, date: string): Observable<Szza020aResponse> {

    // リクエスト生成
    let request: Szza020aRequest = {
      bankMasterSrchInfDto : this.createRequestCustomize(extBankfcCode, extBranchCode, date)
    };

    return this.szza020aService.a10RSZZA020APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZZA020A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * リクエスト業務エリアの生成
   * @param extBankfcCode 外部金融機関コード
   * @param extBranchCode 外部支店コード
   * @param date 日付
   * @returns リクエスト業務エリア
   * @memberof UsedSgkd02dSzza020aService
   */
  private createRequestCustomize(extBankfcCode: string, extBranchCode: string, date: string): Szza020aRequestBankMasterSrchInfDto {
    return {
      // 外部金融機関コード
      extBankfcCode : extBankfcCode,
      // 外部支店コード
      extBranchCode : extBranchCode,
      // 適用開始日付（To）
      applyStartDateTo : date
    }
  }
}
